/** 画布编辑器快捷键说明（与 shortcutKey.js、Editor 行为保持一致） */
export const CANVAS_SHORTCUT_GROUPS = [
  {
    title: "编辑",
    items: [
      { keys: "Ctrl + Z", desc: "撤销上一步操作" },
      { keys: "Ctrl + Y", desc: "重做" },
      { keys: "Ctrl + S", desc: "保存当前页面到草稿" },
      { keys: "Ctrl + C", desc: "复制选中组件" },
      { keys: "Ctrl + X", desc: "剪切选中组件" },
      { keys: "Ctrl + V", desc: "在鼠标位置附近粘贴组件" },
      { keys: "Delete", desc: "删除选中组件或多选组件" },
      { keys: "Ctrl + E", desc: "清空画布（保留背景）" },
    ],
  },
  {
    title: "组合与锁定",
    items: [
      { keys: "Ctrl + G", desc: "组合框选组件" },
      { keys: "Ctrl + B", desc: "拆分组合组件" },
      { keys: "Ctrl + L", desc: "锁定当前组件" },
      { keys: "Ctrl + U", desc: "解锁当前组件" },
    ],
  },
  {
    title: "画布视图",
    items: [
      { keys: "Alt + 滚轮", desc: "以鼠标位置为锚点缩放画布" },
      { keys: "空格 + 拖拽", desc: "平移画布视口" },
      { keys: "页面列表定位图标", desc: "将画布居中到当前视口" },
      { keys: "Alt + 1", desc: "展开或收起左侧页面栏" },
      { keys: "Alt + 2", desc: "展开或收起右侧属性栏" },
      { keys: "Ctrl + P", desc: "预览" },
    ],
  },
  {
    title: "选择",
    items: [
      { keys: "鼠标拖拽", desc: "框选区域内组件；含多种类型时松手后可筛选类型" },
      { keys: "Shift + 左键", desc: "点选追加或取消多选（不误框其它元素）" },
    ],
  },
  {
    title: "移动选中",
    items: [
      { keys: "↑ ↓ ← →", desc: "微移选中组件或框选区域（每次 1px）" },
    ],
  },
];
